import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
};
const theme = createSlice({
  name: "theme",
  initialState,
  reducers: {
    switchTheme: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
  },
});

export const { switchTheme } = theme.actions;

export default theme.reducer;
